import { HttpService } from "./httpService";

export class storeService {
    
    static getStore = async () => {
        return HttpService.get('/store');
    }

    static createStore = async (store: {brandName:string,url:string}) => {
        return HttpService.post('/store', store);
    }

    static updateStore = async (store: any) => {
        return HttpService.patch('/store', store);
    }

    static toggleBanner = async () => {
        return HttpService.patch('/store/toggle-banner', {});
    }


}